import {
  confirmUser,
  resetPassword,
  suspendUser,
  liftSuspension,
  findUserForImpersonation,
} from '@/models/admin'

const adminConfirmUser = async (context, email) => {
  try {
    await confirmUser(email)
    context.dispatch('app/setNotification', 'User was successfully confirmed', {
      root: true,
    })
  } catch (errorObj) {
    console.log(errorObj)
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, {
      root: true,
    })
  }
}

const adminResetPassword = async (context, emailAndPassword) => {
  try {
    await resetPassword(emailAndPassword)
    const { password } = emailAndPassword
    context.dispatch('setNewPassword', password)
    context.dispatch(
      'app/setNotification',
      `Password was changed successfuly changed to ${password}`,
      {
        root: true,
      }
    )
  } catch (errorObj) {
    const { error } = errorObj
    const message = error && error.message ? error.message : 'User not found'
    context.dispatch('app/setError', message, { root: true })
  }
}

const adminSuspendUser = async (context, email) => {
  try {
    await suspendUser(email)
    context.dispatch('app/setNotification', 'User was successfully suspended', {
      root: true,
    })
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, {
      root: true,
    })
  }
}

const adminLiftSuspension = async (context, email) => {
  try {
    await liftSuspension(email)
    context.dispatch(
      'app/setNotification',
      'User was successfully unsuspended',
      {
        root: true,
      }
    )
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, {
      root: true,
    })
  }
}

const adminFindUserForImpersonation = async (context, email) => {
  try {
    const response = await findUserForImpersonation(email)
    context.commit('ADMIN_USER_FOR_IMPERSONATION_UPDATED', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, {
      root: true,
    })
  }
}
const setNewPassword = (context, password) => {
  context.commit('ADMIN_NEW_USER_PASSWORD_UPDATED', password)
}

export default {
  adminConfirmUser,
  adminResetPassword,
  adminSuspendUser,
  adminLiftSuspension,
  adminFindUserForImpersonation,
  setNewPassword,
}
